import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { MatxTheme } from "./components";
import SettingsProvider from "./context/SettingsContext";
import routes from "./routes";
import { ProvideAuth } from "./context/AuthContext";

import React, { useState, useEffect } from 'react'; 
import { useDispatch } from 'react-redux';
import { USER_REQUEST } from "app/redux/actions/utilities";
import Loading from "app/components/MatxLoading"; 

export default function App() {
  const content = useRoutes(routes);
  const dispatch = useDispatch();

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const user = JSON.parse(storedUser);
        dispatch({
          type: USER_REQUEST.LOGIN_SUCCESS,
          payload: user,
        });
      }
    } catch (error) {
      console.error("Could not load user from localStorage", error);
      localStorage.removeItem('user');
    } finally {

      setIsInitialized(true);
    }
  }, [dispatch]);


  if (!isInitialized) {
    return <Loading />;
  }
  return (
    <ProvideAuth>
      <SettingsProvider>
        <MatxTheme>
          <CssBaseline />
          {content}
        </MatxTheme>
      </SettingsProvider>
    </ProvideAuth>
  );
}